const inputStyle = {
	inputContainer: [
		"flex",
		"justify-between",
		"items-center",
		"text-sm",
		"font-bold",
		"px-3",
		"py-2",
		"mt-2",
		"rounded-xl",
	].join(" "),
	secondarySimple: [
		"bg-charcoal-50",
		"text-charcoal-900",
		"border",
		"border-charcoal-50",
		"focus-within:bg-white",
		"focus-within:border-charcoal-300",
		"focus-within:border-bluetiful-400",
	].join(" "),
	secondaryOutline: [
		"bg-white",
		"text-charcoal-900",
		"border",
		"border-charcoal-200",
		"focus-within:border-bluetiful-400",
	].join(" "),
	secondaryOutlineSuccess: [
		"bg-white",
		"text-charcoal-900",
		"border",
		"border-aquamarine-400",
		"focus-within:border-aquamarine-400",
	].join(" "),
	secondaryOutlineError:
		[
			"bg-white",
			"text-charcoal-900",
			"text-charcoal-900",
			"border",
			"border-rojo-400 focus-within:border-rojo-400",
		].join(" "),
  borderBottom: [
    "bg-white border-b-2 border-charcoal-200",
  ],
  borderBottomError: [
    "bg-white border-b-2 border-rojo-400",
  ],
	borderLess: [
		"bg-transparent",
		"border-none",
	].join(" "),
	disabled: [
		"bg-charcoal-50",
		"border",
		"border-charcoal-300",
	].join(" "),
}

export default inputStyle
